/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/qaTemplateLocationBasket.ts
 * FILE_ID: QA-TEMPLATES-LOCATION-BASKET-001
 * PURPOSE: Check or clear every template in one location type.
 * Reused from: packages/job-hub/src/jobs/tabs/job-qa/start-templates/qaStartTemplatesSelection.ts (toggleLocation)
 */
import type { QaTemplateDetail } from '../../../qa/qaTemplateTypes'
import type { QaTemplateLocationGroup } from './qaTemplateCatalog'
import type { QaTemplateSelection } from './useQaTemplatePicker'

function seed(detail: QaTemplateDetail): QaTemplateSelection {
  const sectionIds = new Set<string>()
  const itemIds: Record<string, Set<string>> = {}
  for (const section of detail.sections) {
    if (section.is_optional) {
      itemIds[section.id] = new Set()
      continue
    }
    itemIds[section.id] = new Set(section.items.map((item) => item.id))
    if (section.items.length > 0) sectionIds.add(section.id)
  }
  return { sectionIds, itemIds, sectionTitles: {}, itemTitles: {} }
}

export function openTemplateSeed(detail: QaTemplateDetail) {
  const picked = seed(detail)
  return { selectedSectionIds: picked.sectionIds, selectedItemIds: picked.itemIds }
}

export function locationCheckState(
  group: QaTemplateLocationGroup | undefined,
  basket: Record<string, QaTemplateSelection>,
): boolean | 'mixed' {
  if (!group || group.templates.length === 0) return false
  const picked = group.templates.filter((template) => template.id in basket).length
  if (picked === 0) return false
  if (picked === group.templates.length) return true
  return 'mixed'
}

export function basketForLocation(
  basket: Record<string, QaTemplateSelection>,
  group: QaTemplateLocationGroup,
  detailsById: Record<string, QaTemplateDetail>,
  on: boolean,
): Record<string, QaTemplateSelection> {
  const next = { ...basket }
  for (const template of group.templates) {
    if (!on) {
      delete next[template.id]
      continue
    }
    const detail = detailsById[template.id]
    if (!detail) continue
    next[template.id] = seed(detail)
  }
  return next
}
